import { render, staticRenderFns } from "./bible.vue?vue&type=template&id=6ece8a7d&scoped=true"
import script from "./bible.vue?vue&type=script&lang=js"
export * from "./bible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece8a7d",
  null
  
)

export default component.exports